module.exports = __webpack_public_path__ + "assets/img/logo-greyscale.1bfc1f1f.svg";